module.exports = __webpack_public_path__ + "img/delano7.7fe191d8.jpg";